"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AggregatedOrderPayments = void 0;
const class_transformer_1 = require("class-transformer");
const class_validator_1 = require("class-validator");
const Payment_1 = require("../models/Payment");
class AggregatedOrderPayments {
    payments;
    payableEntity;
}
exports.AggregatedOrderPayments = AggregatedOrderPayments;
__decorate([
    (0, class_validator_1.IsArray)(),
    (0, class_validator_1.IsDefined)(),
    (0, class_transformer_1.Expose)(),
    (0, class_transformer_1.Type)(() => Payment_1.Payment),
    __metadata("design:type", Array)
], AggregatedOrderPayments.prototype, "payments", void 0);
//# sourceMappingURL=AggregatedOrderPayments.js.map